import { render, staticRenderFns } from "./HelperTextPopup.vue?vue&type=template&id=52aaa30f&"
import script from "./HelperTextPopup.vue?vue&type=script&setup=true&lang=js&"
export * from "./HelperTextPopup.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports